// Modules
import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[input-only-number]',
    standalone: false
})
export class OnlyNumberDirective {
  // Private variables
  private _regex = /^[0-9]+$|^[0-9]+(\.[0-9]+)?$/g;

  // Host listener
  // @HostListener('input', ['$event']) onInput(event: InputEvent) {
  //   this._elementRef.nativeElement.value = (<HTMLInputElement>event.currentTarget).value.replace(this._regex, '');
  // }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (charCode !== 46 && charCode !== 13 && (charCode < 48 || charCode > 57))
      event.preventDefault();
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pasteData = event.clipboardData.getData('text/plain');
    if (!this._regex.test(pasteData)) event.preventDefault();
  }

  // Constructor
  constructor(private _elementRef: ElementRef) {}
}
